import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ActivityItem = ({ checked, disabled, onChange, title, description, noOfOpenSpots, noOfParticipants, participants }) => {
    return (
        <div className='d-flex w-100' style={{ marginTop: '0.5rem' }} >
            <Checkbox
                sx={{
                    padding: 0,
                }}
                checked={checked}
                disabled={disabled}
                onChange={onChange}
                inputProps={{ 'aria-label': 'controlled' }}
            />
            <div className='w-100 ml-2'>
                <Accordion sx={{ width: 'inherit' }} >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="activity-content"
                        id="activity-header"
                    >
                        <div>
                            <Typography><b>{title}</b> <i>{noOfOpenSpots === 0 ? 'FULLBOKAD' : ''} {noOfOpenSpots !== 0 && noOfOpenSpots < noOfParticipants ? `Enbart plats för ${noOfOpenSpots} personer` : ''}</i></Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            {description !== null && description.length > 0 ? description : "Information/beskrivning saknas för aktiviteten"}
                        </Typography>
                        <div style={{ height: '1rem' }} ></div>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography><b>Se anmälda deltagare:</b></Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {participants && participants.length > 0 &&
                                    <ul className='ul-no-bullets'>
                                        {participants.sort((a, b) => a.localeCompare(b)).map((p) => (<li key={p}>{p}</li>))}
                                    </ul>}
                                {(!participants || participants.length === 0) && <p>Inga deltagare är anmälda till denna aktivitet ännu.</p>}
                            </AccordionDetails>
                        </Accordion>
                    </AccordionDetails>
                </Accordion>
            </div>
        </div>
    );
}

export default ActivityItem